import { useEffect, useState } from 'react';

import { marketingAnchors } from '~/marketing/landingContent';
import { HeroEmailCapture } from './HeroEmailCapture';
import './landingRef.css';

export function MobileStickyCtaBar({ door }: { door?: string } = {}) {
  const [dismissed, setDismissed] = useState(false);
  const [waitlistVisible, setWaitlistVisible] = useState(false);

  useEffect(() => {
    const el = document.getElementById(marketingAnchors.waitlist);
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        setWaitlistVisible(Boolean(entry?.isIntersecting));
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  if (dismissed || waitlistVisible) {
    return null;
  }

  return (
    <div className="mobile-sticky-bar" role="region" aria-label="Join the waitlist">
      <HeroEmailCapture
        source={door ? `landing-mobile-sticky-${door}` : 'landing-mobile-sticky'}
        inputId="mobile-sticky-waitlist-email"
        className="mobile-sticky-bar__form"
      />
      <button
        type="button"
        className="mobile-sticky-bar__dismiss"
        aria-label="Dismiss waitlist bar"
        onClick={() => setDismissed(true)}>
        ×
      </button>
    </div>
  );
}
